class Booking extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            test: "testString",
            maxPtSize: '',
            secondCheckbox: $('#second-checkbox').text(),
            step: 1,
            reservationChoices: [],
            token: "",
            type: "",
            requestDate: new Date().toISOString().slice(0,10),
            requestTime: "19:00",
            requestParty: "1",
            selectedTime: "",
            reservation_token: "",
            submitFirstName: "",
            submitLastName: "",
            submitEmail: "",
            submitNumber: "",
            submitComments: "",
            submitFirstVisit: false,
            submitNewsletter: false,
            submitCovidCheck: false,
            credCardReq: false,
            submitCardNumber: "",
            submitCardExpMonth: "",
            submitCardExpYear: "",
            submitCardCVC: ""
        };

        const self = this;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        $(function() {
            $( "#ot-datepicker" ).datepicker({
                minDate: 0,
                maxDate: "+6M +0D",
                dateFormat: "yy-mm-dd",
                onSelect: function() {
                    var date = $(this).datepicker('getDate');
                    self.setState({ requestDate: $.datepicker.formatDate("yy-mm-dd", date)});
                }
            });
        });
        window.onhashchange = function() {
            if($(location).attr('href').substr(-1) < self.state.step && $(location).attr('href').substr(-1) < 4){
                self.setState({
                    step : (self.state.step - 1)
                })
            }
        }

    }

    componentDidMount(){
        console.log('Opentable Ready!');
        if(wasOpenTableOptions.event['maxPtSize'] !== ""){
            this.setState({maxPtSize: (parseInt(wasOpenTableOptions.event['maxPtSize']) + 1)});
        } else {
            this.setState({maxPtSize: wasOpenTableOptions['maxSize']});
        }

        //console.log(wasOpenTableOptions.maxSize);
        //console.log(wasOpenTableOptions.event);

        $("#book-form-link").click(function(e){
            e.preventDefault();
            $("#formstack-link").toggle();
        });

        if (typeof gtag === "function") {
            gtag('event', 'Page Load', {
                'event_category': 'Book tracking',
                'event_label': 'Booking Stage 1',
                'value': '1'
            });
        }

        document.getElementById('open-times-container-div').innerHTML = document.getElementById('opening-times').innerHTML;

        //fbq.push(['track', 'CustomerBooking1', {}]);
        //fbq('track', 'CustomerBooking2');
        //window._fbq.push(['track', 'CustomerBooking3', {}]);

    }

    componentDidUpdate(){
        const self = this;
        $(function() {
            $( "#ot-datepicker" ).datepicker({
                minDate: 0,
                maxDate: "+6M +0D",
                dateFormat: "yy-mm-dd",
                onSelect: function() {
                    var date = $(this).datepicker('getDate');
                    self.setState({ requestDate: $.datepicker.formatDate("yy-mm-dd", date)});
                }
            });
            $("#ot-datepicker").datepicker("setDate", self.state.requestDate);
            if(self.state.step === 1){
                document.getElementById('was-ot-powered').style.display = 'none';
            }

        });
        if(this.state.step == 1){
            document.getElementById('booking-formstack').style.display = 'block';
        }
        if(this.state.secondCheckbox === ""){
            $('#secondInputBoxLabel').hide();
        }

        if(this.state.requestParty >= wasOpenTableOptions.credCardPtSize && wasOpenTableOptions.credCardPtSize !== "" && wasOpenTableOptions.credCardPtSize !== "0"){
            $('#ot-card-text-wrapper').show();
        } else {
            $('#ot-card-text-wrapper').hide();
        }
    }

    handleChange(e){
        this.setState({ [e.target.name] : e.target.value});
        this.forceUpdate();
        //console.log(this.state);
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.name === target.name ? target.checked : target.value;
        const name = target.name;

        this.setState({[name]: value });

        this.forceUpdate();
        //console.log(this.state);
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    // FETCH REQUESTS
    // FETCH REQUESTS // FETCH REQUESTS
    // FETCH REQUESTS // FETCH REQUESTS // FETCH REQUESTS

    getToken(){
        const self = this;
        fetch('/wp-json/reservations/1', {
            method: 'GET',
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                response.json().then(function(data) {
                    //console.log(data);
                    self.getAvailability(data['access_token']);
                    self.setState({token: data['access_token']});
                    window.location.hash = '1';
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    getAvailability(token){
        const self = this;
        document.getElementById('errors').innerHTML = "";

        var url = '/wp-json/reservations/2?access_token=' + token;

        if(this.state.requestDate !== ""){ url = url + "&request_date=" + this.state.requestDate; }
        if(this.state.requestTime !== ""){ url = url + "&request_time=" + this.state.requestTime; }
        if(this.state.requestParty !== ""){ url = url + "&request_party=" + this.state.requestParty; }

        // Events Enquiry

        if(this.state.requestParty >= parseInt(wasOpenTableOptions.event['minPtSize'])){

            var startDate = new Date(wasOpenTableOptions.event['startDate'].split('/')[2],(wasOpenTableOptions.event['startDate'].split('/')[1] - 1),wasOpenTableOptions.event['startDate'].split('/')[0]);
            var endDate = new Date(wasOpenTableOptions.event['endDate'].split('/')[2],(wasOpenTableOptions.event['endDate'].split('/')[1] - 1),wasOpenTableOptions.event['endDate'].split('/')[0]);
            var requestFormattedDate = new Date(this.state.requestDate.split('-')[0],(this.state.requestDate.split('-')[1] - 1),this.state.requestDate.split('-')[2]);
            var inIFrame = wasOpenTableOptions.event['openInIFrame']!='0';

            if(requestFormattedDate >= startDate && requestFormattedDate <= endDate){
                document.getElementById('errors').innerHTML += 
                            '<p><a ccdev="456" '+(inIFrame ? ' data-action="load-iframe" ' : '')
                            +' href="'+wasOpenTableOptions.event['link']+'"'
                            +(inIFrame ? ' target="was-special-event-iframe" ' : ' target="_blank" ')
                            +'style="text-decoration: underline;">'
                            +wasOpenTableOptions.event['textArea']
                            +'</a></p>';
                return;
            }
        }

        // Events end

        fetch( url, {
            method: 'GET'
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                response.json().then(function(data){
                    if(data.times_available){
                        //console.log(data.times_available);
                        self.setState({
                            reservationChoices: data.times_available,
                            step: 2,
                            type: data.times_available[0].attribute
                        });
                        window.location.hash = '2';
                        document.getElementById('was-ot-powered').style.display = 'block';
                        document.getElementById('booking-formstack').style.display = 'none';
                        if (typeof gtag === "function") {
                            gtag('event', 'booking_stage_2', {
                                'event_catebgory': 'Book tracking',
                                'event_label': 'Booking Stage 2',
                                'value': '2'
                            });
                        }
                    } else {
                        var myDiv = document.getElementById('was-opentable');
                        myDiv.scrollIntoView();
                        document.getElementById('errors').innerHTML += '<p>'+document.getElementById('no-availability').innerHTML+'</p>';
                        if (typeof gtag === "function") {
                            var d = new Date(self.state.requestDate);

                            var weekday = new Array(7);
                            weekday[0] = "Sunday"; weekday[1] = "Monday"; weekday[2] = "Tuesday"; weekday[3] = "Wednesday"; weekday[4] = "Thursday"; weekday[5] = "Friday"; weekday[6] = "Saturday";

                            var n = weekday[d.getDay()];

                            gtag('event', 'No Booking Availability', {
                                'event_category': 'Booking Availability',
                                'event_label': 'Booking attempt: '+self.state.requestDate+' ('+n+') | '+self.state.requestTime+' | '+self.state.requestParty,
                                'value': '1'
                            });
                        }
                    }

                }).then(self.renderTimesAvailable(self.state.reservationChoices));
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    lockSlot(timeChoice){
        //console.log(timeChoice);
        this.setState({credCardReq : timeChoice.credit_card_required});

        if (!Date.prototype.toISODate) {
            Date.prototype.toISODate = function() {
              return this.getFullYear() + '-' +
                     ('0'+ (this.getMonth()+1)).slice(-2) + '-' +
                     ('0'+ this.getDate()).slice(-2);
            }
        }

        var formattedDate = new Date(timeChoice.time).toISODate();
        //var x = new Date(timeChoice);
        var timeChoiceArray = timeChoice.time.split("T", 2);
        //console.log(timeChoice[1]);
        //var formattedDateTime = formattedDate+"T"+x.getHours()+":"+x.getMinutes()+(x.getMinutes()<10?'0':'');
        var formattedDateTime = formattedDate+"T"+timeChoiceArray[1];
        //console.log(formattedDateTime);
        const self = this;

        this.setState({
            selectedTime: formattedDateTime
        });

        var url = '/wp-json/reservations/3?access_token='+this.state.token;

        if(this.state.requestDate !== ""){ url = url + "&request_date=" + this.state.requestDate; }
        if(this.state.requestTime !== ""){ url = url + "&request_time=" + formattedDateTime; }
        if(this.state.requestParty !== ""){ url = url + "&request_party=" + this.state.requestParty; }
        if(this.state.type !== ""){ url = url + "&request_type=" + this.state.type; }

        fetch(url, {
            method: 'GET',
        }).then(
            function(response) {
                if(response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                //console.log(response);
                response.json().then(function(data) {
                    //console.log(data);
                    self.setState({
                        step: 3,
                        reservation_token: data.reservation_token,
                        selectedTime: timeChoice.time
                    });
                    window.location.hash = '3';
                    if (typeof gtag === "function") {
                        gtag('event', 'booking_stage_3', {
                            'event_category': 'Book tracking',
                            'event_label': 'Booking Stage 3',
                            'value': '3'
                        });
                    }
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    submitReservation(){
        const self = this;

        document.getElementById('errors').innerHTML = "";

        // CREDIT CARD EDITS
        if(this.state.credCardReq === true){
            var cardUrl = '/wp-json/reservations/5?access_token='+this.state.token;

            if(this.state.submitCardNumber !== ""){ cardUrl = cardUrl + "&submit_cardnumber=" + this.state.submitCardNumber; }
            if(this.state.submitCardExpMonth !== ""){ cardUrl = cardUrl + "&submit_cardmonth=" + this.state.submitCardExpMonth; }
            if(this.state.submitCardExpYear !== ""){ cardUrl = cardUrl + "&submit_cardyear=" + this.state.submitCardExpYear; }
            if(this.state.submitCardCVC !== ""){ cardUrl = cardUrl + "&submit_cardcvc=" + this.state.submitCardCVC; }


            fetch(cardUrl, {
                method: 'GET',
            }).then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                        return;
                    }
                    //console.log(response);
                    response.json().then(function(data) {
                        //console.log(data);
                        if(data.errors){
                            if(data.errors.length > 0){
                                if(data.errors[0].details){
                                    if(data.errors[0].details.overlappingReservation1){
                                        //document.getElementById('errors').innerHTML += '<p>'+data.errors[0].message+'</p>';
                                        document.getElementById('errors').innerHTML += '<p> - Sorry we are experiencing difficulties with online bookings. Please check your email for a confirmation and contact the restaurant directly if you have not received one in the next 5 minutes.</p>';
                                    } else {
                                        for (let index = 0; index < data.errors.length; index++) {
                                            if (typeof data.errors[index] === 'string' || data.errors[index] instanceof String){
                                                document.getElementById('errors').innerHTML += '<p>'+data.errors[index]+'</p>';
                                            }
                                        }
                                    }
                                } else {
                                    for (let index = 0; index < data.errors.length; index++) {
                                        if (typeof data.errors[index] === 'string' || data.errors[index] instanceof String){
                                            document.getElementById('errors').innerHTML += '<p>'+data.errors[index]+'</p>';
                                        }
                                    }
                                }

                                if(data.errors[0].message){
                                    for (let index = 0; index < data.errors.length; index++) {
                                        //document.getElementById('errors').innerHTML += '<p>'+data.errors[index].message+'</p>';
                                        document.getElementById('errors').innerHTML += '<p>There has been a problem booking your table. Please contact us for assistance.</p>';
                                    }
                                }

                            }
                            var myDiv = document.getElementById('was-opentable');
                            myDiv.scrollIntoView();
                            return;
                        }
                        if(data.error){
                            document.getElementById('errors').innerHTML += '<p>'+data.error.message+'</p>';
                            var myDiv = document.getElementById('was-opentable');
                            myDiv.scrollIntoView();
                            return;
                        }
                        self.submitBookingForm(true, data.id, data.card.last4);
                    });
                }
            );
        } else {
            self.submitBookingForm(false, null, null);
        }
    }

    submitBookingForm(CC, token, last4){
        const self = this;

        ///////

        document.getElementById('errors').innerHTML = "";

        var url = '/wp-json/reservations/4?access_token='+this.state.token;

        if(this.state.reservation_token !== ""){ url = url + "&submit_token=" + this.state.reservation_token; }
        if(this.state.submitFirstName !== ""){ url = url + "&submit_fname=" + this.state.submitFirstName; }
        if(this.state.submitLastName !== ""){ url = url + "&submit_lname=" + this.state.submitLastName; }
        if(this.state.submitEmail !== ""){ url = url + "&submit_email=" + this.state.submitEmail; }
        if(this.state.submitNumber !== ""){ url = url + "&submit_number=" + this.state.submitNumber; }
        if(this.state.submitComments !== ""){ url = url + "&submit_comments=" + this.state.submitComments; }
        if(this.state.type !== ""){ url = url + "&submit_type=" + this.state.type; }
        if(this.state.submitFirstVisit !== ""){ url = url + "&submit_visit=" + this.state.submitFirstVisit; }
        if(this.state.submitNewsletter !== ""){ url = url + "&submit_newsletter=" + this.state.submitNewsletter; }
        if(this.state.submitCovidCheck !== ""){ url = url + "&submit_covid=" + this.state.submitCovidCheck; }
        // CC
        if(CC) {
            if(CC !== false){ url = url + "&submit_cc=" + "true"; }
            if(token !== ""){ url = url + "&submit_cctoken=" + token; }
            if(last4 !== ""){ url = url + "&submit_cclast4=" + last4; }
        }

        fetch(url, {
            method: 'GET',
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                console.log(response);
                response.json().then(function(data) {
                    console.log(data);
                    if(data.errors){
                        if(data.errors.length > 0){
                            if(data.errors[0].details){
                                if(data.errors[0].details.overlappingReservation1){
                                    //document.getElementById('errors').innerHTML += '<p>'+data.errors[0].message+'</p>';
                                    document.getElementById('errors').innerHTML += '<p> - Sorry we are experiencing difficulties with online bookings. Please check your email for a confirmation and contact the restaurant directly if you have not received one in the next 5 minutes.</p>';
                                }
                            } else if(data.errors.length > 0) {
                                for (let index = 0; index < data.errors.length; index++) {
                                    if (typeof data.errors[index] === 'string' || data.errors[index] instanceof String){
                                        document.getElementById('errors').innerHTML += '<p>'+data.errors[index]+'</p>';
                                    }
                                }
                            }
                            if(data.errors[0].message){
                                for (let index = 0; index < data.errors.length; index++) {
                                    //document.getElementById('errors').innerHTML += '<p>'+data.errors[index].message+'</p>';
                                    document.getElementById('errors').innerHTML += '<p>There has been a problem booking your table. Please contact us for assistance.</p>';
                                }
                            }
                        }
                        var myDiv = document.getElementById('was-opentable');
                        myDiv.scrollIntoView();
                    } else {
                        self.setState({
                            step: 4
                        });
                        window.location.hash = '4';
                        document.getElementById('message').innerHTML += '<p>'+data.message+'</p>';
                        if(self.state.credCardReq === true){
                            document.getElementById('message').innerHTML += '<p>For parties of 5 or more, we require a credit card to secure your booking. It will only be charged should you cancel with less than 24 hours notice, at £10 per person.</p>';

                        }
                        document.getElementById('manage-booking').href = data.manage_reservation_url;
                        document.getElementById('booking-reference').innerHTML = data.confirmation_number;
                        if (typeof gtag === "function") {
                            gtag('event', 'booking_confirmed', {
                                'event_category': 'Book tracking',
                                'event_label': 'Booking Stage - Completed',
                                'value': '4'
                            });
                        }

                        fbq.push(['track', 'Completed Booking', {}]);
                        /*****
                         * Newsletter bit
                         * ****** */
                        //if(self.state.submitNewsletter === true){
                            self.optInNewsletter(data);
                        //}
                    }
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    optInNewsletter(reservationInfo){
        const self = this;

        var atreemoUrl = '/wp-json/atreemo/1?reservation=true';

        if(this.state.submitFirstName !== ""){ atreemoUrl = atreemoUrl + "&submit_fname=" + this.state.submitFirstName; }
        if(this.state.submitLastName !== ""){ atreemoUrl = atreemoUrl + "&submit_lname=" + this.state.submitLastName; }
        if(this.state.submitEmail !== ""){ atreemoUrl = atreemoUrl + "&submit_email=" + this.state.submitEmail; }
        if(this.state.submitNewsletter !== ""){ atreemoUrl = atreemoUrl + "&submit_newsletter=" + this.state.submitNewsletter; }

        // reservationInfo
        if(reservationInfo.confirmation_number !== ""){ atreemoUrl = atreemoUrl + "&submit_resref=" + reservationInfo.confirmation_number; }
        if(reservationInfo.date_time !== ""){ atreemoUrl = atreemoUrl + "&submit_datetime=" + reservationInfo.date_time ; }
        if(reservationInfo.manage_reservation_url !== ""){ atreemoUrl = atreemoUrl + "&submit_resurl=" + reservationInfo.manage_reservation_url ; }
        if(this.state.requestParty !== ""){ atreemoUrl = atreemoUrl + "&submit_ptsize=" + this.state.requestParty ; }
        if(this.state.type !== ""){ atreemoUrl = atreemoUrl + "&request_type=" + this.state.type; }


        fetch(atreemoUrl, {
            method: 'GET',
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                response.json().then(function(data) {
                    console.log("newsletter check");
                    console.log(data);
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    // END FETCH REQUESTS
    // END FETCH REQUESTS // END FETCH REQUESTS
    // END FETCH REQUESTS // END FETCH REQUESTS // END FETCH REQUESTS

    renderPartyOptions(){
        var min = 1;
        var max = this.state.maxPtSize;
        var sizes = [];

        for (var i=min;i<max; i++) { sizes[i] = i; }

        return sizes.map((size) =>
            <option value={size}>{size}</option>
        )
    }

    renderTimeOptions(){
        var x = 15;
        var times = [];
        var tt = 420;

        for(var i=0; tt < 24 * 60; i++){
            var hh = Math.floor(tt/60);
            var mm = (tt%60);
            times[i] = ("0" + (hh)).slice(-2) + ':' + ("0" + mm).slice(-2);
            tt = tt + x;
        }

        return times.map((time) =>
            <option value={time}>{time}</option>
        )
    }

    renderAreasText(reservationChoices, requestDate, requestTime){
        var requestedDate = `${requestDate}T${requestTime}`;
        var diningAvailable = false;
        for (let index = 0; index < reservationChoices.length; index++) {
            if(requestedDate == reservationChoices[index].time){
                var diningAvailable = true;
            }
        }
        if(diningAvailable == false){
            return(
                <p><strong>Our eatery is looking busy at the time you’ve selected, please see what’s available below.</strong></p>
            )
        }
    }

    renderAreasAvailable(reservationChoices){
        var reservationChoicesType = []
        //console.log(reservationChoices);
        if(reservationChoices.length > 0){
            reservationChoices.map((choice) => {
                if(!reservationChoicesType.includes(choice.attribute)){
                    reservationChoicesType.push(choice.attribute);
                }
            });
            // Edit Table Types
            //if(window.location.hostname !== "dev.fleecewitney.co.uk"){
            /*
            if(window.location.hostname !== "www.highfieldedgbaston.co.uk"){
                return (
                    reservationChoicesType.map((type, index) =>
                        <div className="radio-btn"><input type="radio" name="type" id={type} value={type} className={type} checked={type === this.state.type} onChange={this.handleChange}/><label for={type}>{(type == 'default') ? "Dining" : (type == 'bar') ? "Drinking" : type}</label></div>
                    )
                );
            } else {
                return (
                    reservationChoicesType.map((type, index) =>
                        <div className="radio-btn"><input type="radio" name="type" id={type} value={type} className={type} checked={type === this.state.type} onChange={this.handleChange}/><label for={type}>{(type == 'default') ? "Dining" : (type == 'bar') ? "Drinking" : (type == 'highTop') ? "Studio" : type}</label></div>
                    )
                );
            }
            */
            return (
                reservationChoicesType.map((type, index) =>
                    <div className="radio-btn"><input type="radio" name="type" id={type} value={type} className={type} checked={type === this.state.type} onChange={this.handleChange}/><label for={type}>{(type == 'default') ? wasOpenTableOptions.tableTypes.default.name : (type == 'bar') ? wasOpenTableOptions.tableTypes.bar.name : (type == 'highTop') ? wasOpenTableOptions.tableTypes.hightop.name : (type == 'counter') ? wasOpenTableOptions.tableTypes.counter.name : (type == 'outdoor') ? wasOpenTableOptions.tableTypes.outdoor.name : type} <a href="#" data-tooltip={(type == 'default') ? wasOpenTableOptions.tableTypes.default.desc : (type == 'bar') ? wasOpenTableOptions.tableTypes.bar.desc : (type == 'highTop') ? wasOpenTableOptions.tableTypes.hightop.desc : (type == 'outdoor') ? wasOpenTableOptions.tableTypes.outdoor.desc : (type == 'counter') ? wasOpenTableOptions.tableTypes.counter.desc : ""}>I</a></label></div>
                )
            );
        }
    }

    formatTime(time){
        var timeArray = time.split("T", 2);
        //console.log(timeArray[1]);
        var x = new Date(time);
        //var formattedTime = x.getHours()+":"+x.getMinutes();
        var formattedTime = x.getHours()+":"+x.getMinutes()+(x.getMinutes()<10?'0':'');
        //return formattedTime;
        return timeArray[1];
    }

    renderFriendlyDate(time){
        var dayArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var x = new Date(time);
        //var year = x.getFullYear();
        var month = x.getMonth();
        //var date = x.getDate();
        var n = time.indexOf('?');
        var date = time.substring(8, n != -1 ? n : time.length);
        var day = x.getDay();
        return dayArray[day]+" "+date+" "+monthArray[month];
    }

    renderTimesAvailable(reservationChoices){
        //console.log(reservationChoices);
        var reservationChoicesArray = reservationChoices;
        if((this.state.requestTime.replace(':','') >= "1199") && (reservationChoicesArray.length > 8)){
            console.log('Filter Day Part');
            reservationChoicesArray.forEach((choice, i) => {
                var choiceTimeArray = choice.time.split("T", 2);
                if((choiceTimeArray[1].replace(':','')) < "1200"){
                    reservationChoicesArray.splice(i, 1);
                }
            });
        }
        if(reservationChoicesArray.length > 0){
            return (
                reservationChoicesArray.map((choice) =>
                    <div className={choice.attribute} style={{display: (choice.attribute === this.state.type ? 'inline-block' : 'none') }}>
                        <button onClick={  (choice.credit_card_required) ? () => (window.location.href = choice.booking_url) : () => this.lockSlot(choice)}>{this.formatTime(choice.time)}</button>
                    </div>
                )
            );
        }
    }

    getTableTypeDescription(){
        return document.getElementById('table-types').textContent;
    }

    cardFields(){
        if(this.state.credCardReq){
            return (
                <div>
                    <hr />
                    <div className="input-wrapper">
                        <label>Card Number *</label>
                        <input type="text" name="submitCardNumber" onChange={this.handleChange}/>
                    </div>
                    <p className="ot-card-text"><span>For parties of 5 or more, a credit card is required to secure your booking. This card will only be charged in the event of a cancellation with less than 24 hours notice, at a fee of £10 per person.</span></p>
                    <br />
                    <div className="input-wrapper">
                        <div className="input-wrapper-split">
                            <label className="spacing">MM / YY *</label>
                            <input type="text" name="submitCardExpMonth" class="small-field" onChange={this.handleChange}/>
                            <span className="slash-divider">/</span>
                            <input type="text" name="submitCardExpYear" class="med-field" onChange={this.handleChange}/>
                        </div>
                        <div className="input-wrapper-split">
                            <label>CVC *</label>
                            <input type="text" name="submitCardCVC" class="med-field" onChange={this.handleChange}/>
                        </div>
                    </div>
                    <hr />
                </div>
            )
        }
    }

    renderStepOne(){
        return (
            <div className="step-1">
                <div className="left">
                    <div id="ot-datepicker"></div>
                </div>
                <div className="right">
                    <div className="input-wrapper">
                        <label>Time</label>
                        <select name="requestTime" value={this.state.requestTime} onChange={this.handleChange}>
                            {this.renderTimeOptions()}
                        </select>
                    </div>
                    <div className="input-wrapper">
                        <label>No. of People</label>
                        <select name="requestParty" value={this.state.requestParty} onChange={this.handleChange}>
                            {this.renderPartyOptions()}
                        </select>
                    </div>
                    <div id="ot-card-text-wrapper">
                        <p className="ot-card-text"><span>For parties of {wasOpenTableOptions.credCardPtSize} or more, a credit card is required to secure your booking. This card will only be charged in the event of a cancellation with less than 24 hours notice, at a fee of £10 per person.</span></p>
                    </div>
                    <div className="input-wrapper">
                        <input type="button" value="Find a Table" onClick={this.getToken.bind(this)}/>
                    </div>
                    <div id="errors"></div>
                </div>
            </div>
        );
    }

    renderStepTwo(){
        return (
            <div className="step-2">
                <h4>CHOOSE TABLE TYPE</h4>
                {this.renderAreasText(this.state.reservationChoices, this.state.requestDate, this.state.requestTime)}
                <p>Options available for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.state.requestTime} <span onClick={() => this.setState({step: 1})}>(change details)</span></p>
                <div className="radio-wrapper">
                    {this.renderAreasAvailable(this.state.reservationChoices)}
                </div>
                <div className="times-wrapper">
                    <h4>CHOOSE A TIME</h4>
                    {this.renderTimesAvailable(this.state.reservationChoices)}
                </div>
                <p class="table-types">{this.getTableTypeDescription()}</p>
            </div>
        );
    }

    renderStepThree(){
        return (
            <div className="step-3">
                <p>Booking for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.formatTime(this.state.selectedTime)} <span onClick={() => {this.setState({step: 1}); window.location.hash = "1"}}>(change details)</span></p>
                <div id="errors"></div>
                <div className="input-wrapper">
                    <label>Title *</label>
                    <select name="submitSalutation" onChange={this.handleChange}>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Ms">Ms</option>
                        <option value="Miss">Miss</option>
                        <option value="Mx">Mx</option>
                        <option value="Dr">Dr</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div className="input-wrapper">
                    <label>First Name *</label>
                    <input type="text" name="submitFirstName" onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper">
                    <label>Last Name *</label>
                    <input type="text" name="submitLastName" onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper">
                    <label>Email Address *</label>
                    <input type="text" name="submitEmail" onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper">
                    <label>Contact No. *</label>
                    <input type="text" name="submitNumber" onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper">
                    <label>Comments / Special Requests</label>
                    <textarea rows="3" name="submitComments" onChange={this.handleChange}></textarea>
                </div>
                {this.cardFields()}
                <div className="input-wrapper">
                    <label><input class="mr-2" name="submitNewsletter" type="checkbox" checked={this.state.submitNewsletter} onChange={this.handleCheckboxChange} />Tick this box if you are happy for us to email you. Read our full privacy policy <a href="https://makinglifepeachy.com/privacy-policy/" target="_blank">here</a>.</label>
                    <div id="secondInputBoxLabel">
                        <label ><input name="submitCovidCheck" type="checkbox" checked={this.state.submitCovidCheck} onChange={this.handleCheckboxChange} /> {this.state.secondCheckbox}</label>
                    </div>
                </div>
                <div className="input-wrapper">
                    <p>By selecting ‘Confirm’ you are agreeing to the <a href="https://www.opentable.com/legal/terms-and-conditions" target="_blank">Terms & Conditions</a> of the OpenTable User Agreement and <a href="https://www.opentable.com/legal/privacy-policy" target="_blank">Privacy Policy.</a></p>
                    <input type="button" value="Confirm booking" onClick={this.submitReservation.bind(this)}/>
                </div>

            </div>
        );
    }

    renderStepFour(){

        /*if(window.location.hostname == "www.highfieldedgbaston.co.uk"){
            if(this.state.type == "highTop"){
                return (
                    <div className="step-4">
                        <h4>Booking Details:</h4>
                        <p>Booking for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.formatTime(this.state.selectedTime)}</p>
                        <p>Table type: Studio</p>
                        <a id="manage-booking" href="">Cancel Booking</a>
                        <div><p><strong>Please note that the current government curfew means all guests must have left the pub by 10pm.</strong></p></div>
                        <br />
                        <h4>Booking Reference:</h4>
                        <p id="booking-reference"></p>
                        <hr />
                        <div id="message"></div>
                    </div>
                );
            } else {
                return (
                    <div className="step-4">
                        <h4>Booking Details:</h4>
                        <p>Booking for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.formatTime(this.state.selectedTime)}</p>
                        <p>Table type: {(this.state.type == 'default') ? "Dining" : (this.state.type == 'bar') ? "Drinking" : this.state.type.toUpperCase()}</p>
                        <a id="manage-booking" href="">Cancel Booking</a>
                        <div><p><strong>Please note that the current government curfew means all guests must have left the pub by 10pm.</strong></p></div>
                        <br />
                        <h4>Booking Reference:</h4>
                        <p id="booking-reference"></p>
                        <hr />
                        <div id="message"></div>
                    </div>
                );
            }
        } else {
            return (
                <div className="step-4">
                    <h4>Booking Details:</h4>
                    <p>Booking for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.formatTime(this.state.selectedTime)}</p>
                    <p>Table type: {(this.state.type == 'default') ? wasOpenTableOptions.tableTypes.default.name : (this.state.type == 'bar') ? wasOpenTableOptions.tableTypes.bar.name : this.state.type.toUpperCase()}</p>
                    <a id="manage-booking" href="">Cancel Booking</a>
                    <div><p><strong>Please note that the current government curfew means all guests must have left the pub by 10pm.</strong></p></div>
                    <br />
                    <h4>Booking Reference:</h4>
                    <p id="booking-reference"></p>
                    <hr />
                    <div id="message"></div>
                </div>
            );
        }*/

        return (
            <div className="step-4">
                <h4>Booking Details:</h4>
                <p>Booking for {this.state.requestParty} {this.state.requestParty == 1 ? ( 'person' ) : 'people' } on {this.renderFriendlyDate(this.state.requestDate)} at {this.formatTime(this.state.selectedTime)}</p>
                <p>Table type: {(this.state.type == 'default') ? wasOpenTableOptions.tableTypes.default.name : (this.state.type == 'bar') ? wasOpenTableOptions.tableTypes.bar.name : (this.state.type == 'highTop') ? wasOpenTableOptions.tableTypes.hightop.name : (this.state.type == 'counter') ? wasOpenTableOptions.tableTypes.counter.name : (this.state.type == 'outdoor') ? wasOpenTableOptions.tableTypes.outdoor.name : this.state.type.toUpperCase()}</p>
                <a id="manage-booking" href="">Cancel Booking</a>
                <br />
                <h4>Booking Reference:</h4>
                <p id="booking-reference"></p>
                <hr />
                <div id="message"></div>
            </div>
        );


    }

    render() {
        return (
            <div className="was-ot-container">
                <div className="was-ot-header">
                    <div className="ot-back-btn" onClick={() => {this.setState({step : (this.state.step - 1)}); window.location.hash = (this.state.step - 1)}} style={{display: (this.state.step > 1  ? 'block' : 'none') }}>{"< back"}</div>
                    {this.state.step == 1 ? ( <h2>Book a table - Step 1: Enter Details</h2> ) : null }
                    {this.state.step == 2 ? ( <h2>Book a table - Step 2: Table & Time</h2> ) : null }
                    {this.state.step == 3 ? ( <h2>Book a table - Step 3: Confirm</h2> ) : null }
                    {this.state.step == 4 ? ( <h2>Your booking is confirmed</h2> ) : null }
                </div>
                <div className="was-ot-body">
                    <div className="gallery">
                        <div style={{backgroundImage: "url(" + document.getElementById('booking-image').textContent + ")"}}></div>
                        <div id="open-times-container">
                            <h5>Opening Times:</h5>
                            <div id="open-times-container-div"></div>
                        </div>
                    </div>
                    <div className="steps">
                        {this.state.step == 1 ? ( this.renderStepOne() ) : null }
                        {this.state.step == 2 ? ( this.renderStepTwo() ) : null }
                        {this.state.step == 3 ? ( this.renderStepThree() ) : null }
                        {this.state.step == 4 ? ( this.renderStepFour() ) : null }
                    </div>
                </div>
            </div>
        );
    }
}

if(document.getElementById("was-opentable")){
    ReactDOM.render(<Booking />, document.getElementById("was-opentable"));
}
//js becasue I hate react
document.addEventListener('click', (event)=>{
    if(event.target.matches('a[data-action="load-iframe"]'))
    { document.getElementById("was-special-event-link").style.display = 'block';
    }
});